import {emotionStyled} from '@packages/utilities/styled';
import {Select} from '@packages/systems/spring';
import {brandedFontFamily} from '../../constants';

/**
 * `emotionStyled` types are having trouble composing the inferred generic types from `Select` when returning the curried styled component.
 * So, we will just manually set it for now.
 */
// @ts-expect-error - TS2322 - Type 'typeof Select' is not assignable to type 'typeof Select'.
export const BrandedSelect: typeof Select = emotionStyled(Select)({
  padding: '$2',
  span: {
    fontFamily: brandedFontFamily,
    lineHeight: '24px',
  },
  input: {
    '&:focus': {
      boxShadow: 'none',
    },
  },
});
